import React from 'react';
import { User, Film } from 'lucide-react';

// Icono de bot personalizado, más amigable que el default de lucide
const BotAvatar = () => (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="7" width="16" height="13" rx="3.5" fill="white" />
        <circle cx="9" cy="13" r="1.5" fill="#22d3ee" />
        <circle cx="15" cy="13" r="1.5" fill="#22d3ee" />
        <path d="M 9.5 16.5 Q 12 18 14.5 16.5" stroke="#22d3ee" strokeWidth="1.2" strokeLinecap="round" fill="none" />
        <rect x="11" y="3.5" width="2" height="3.5" rx="1" fill="white" />
        <circle cx="12" cy="3" r="1.2" fill="white" />
        <rect x="2.5" y="11" width="1.8" height="4" rx="0.9" fill="white" />
        <rect x="19.7" y="11" width="1.8" height="4" rx="0.9" fill="white" />
    </svg>
);

const ChatMessage = ({ message }) => {
    const isUser = message.role === 'user';

    if (message.role === 'scene') {
        return (
            <div className="flex justify-center my-3">
                <div className="flex items-center gap-2 text-[11px] text-neon-amber/80 italic px-3 py-1.5 border border-amber-300 rounded-full bg-neon-amber/10 max-w-[85%]">
                    <Film className="w-3 h-3 shrink-0" />
                    <span className="leading-relaxed">{message.content}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-3`}>
            <div className={`flex items-end gap-2 max-w-[85%] ${isUser ? 'flex-row-reverse' : 'flex-row'}`}>
                <div className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center" style={{
                    background: isUser ? 'rgba(34, 211, 238, 0.18)' : 'rgba(232, 121, 249, 0.18)',
                    border: `1px solid ${isUser ? 'rgba(34, 211, 238, 0.6)' : 'rgba(232, 121, 249, 0.6)'}`,
                    boxShadow: `0 0 8px ${isUser ? 'rgba(34, 211, 238, 0.3)' : 'rgba(232, 121, 249, 0.3)'}`,
                }}>
                    {isUser ? (
                        <User className="w-3.5 h-3.5 text-neon-cyan" />
                    ) : (
                        <div style={{ color: '#e879f9' }}>
                            <BotAvatar />
                        </div>
                    )}
                </div>

                <div
                    className={`px-4 py-2.5 text-sm leading-relaxed ${
                        isUser ? 'rounded-2xl rounded-br-md' : 'rounded-2xl rounded-bl-md'
                    }`}
                    style={isUser ? {
                        background: 'rgba(34, 211, 238, 0.12)',
                        border: '1px solid rgba(34, 211, 238, 0.4)',
                        color: '#e0f2fe',
                        boxShadow: '0 0 12px rgba(34, 211, 238, 0.15)',
                    } : {
                        background: 'rgba(18, 18, 31, 0.7)',
                        border: '1px solid rgba(232, 121, 249, 0.3)',
                        color: '#f5f5fa',
                        boxShadow: '0 0 12px rgba(232, 121, 249, 0.1)',
                    }}
                >
                    {message._temp_assistant ? (
                        <div className="flex items-center gap-1.5 py-0.5">
                            <span className="w-1.5 h-1.5 bg-neon-magenta rounded-full animate-bounce" />
                            <span className="w-1.5 h-1.5 bg-neon-magenta rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
                            <span className="w-1.5 h-1.5 bg-neon-magenta rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
                        </div>
                    ) : (
                        <p className="whitespace-pre-wrap">
                            {message.content}
                            {message._streaming && (
                                <span
                                    className="inline-block w-1.5 h-3.5 ml-0.5 align-middle animate-pulse"
                                    style={{ background: isUser ? '#22d3ee' : '#e879f9' }}
                                />
                            )}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ChatMessage;
